export const allEqualTo = (arr, value) => arr.every(v => v === value);
